module.exports = __webpack_public_path__ + "img/广州华夏学院图书馆.f81cc6da.png";